import { render, staticRenderFns } from "./album.vue?vue&type=template&id=43120e4b&scoped=true&"
import script from "./album.vue?vue&type=script&lang=js&"
export * from "./album.vue?vue&type=script&lang=js&"
import style0 from "./album.vue?vue&type=style&index=0&id=43120e4b&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./album.vue?vue&type=style&index=1&id=43120e4b&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43120e4b",
  null
  
)

export default component.exports